import React, { useCallback } from "react";
import { connect } from "react-redux";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import LogoIcon from "../../assets/images/logo-icon.png";
import { formTypes, authConstants } from "../../constants";
import RoundedButton from "../../shared/components/buttons/RoundedButton";
import { authActions } from "../../redux/actions";

const schema = Yup.object().shape({
  email: Yup.string()
    .required("Email is required")
    .max(100, "Email must not exceed 100 characters")
    .test(
      "is-valid-email",
      "Invalid email address",
      (value) => !!value && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
    ),
});

const ForgotForm = ({ changeFormType, forgotPassword, spinnerActions }) => {
  // Use yupResolver to integrate Yup with React Hook Form
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema), // Use the Yup schema for validation
  });

  const spinner = useCallback(
    (type) => spinnerActions.findIndex((s) => s === type),
    // eslint-disable-next-line
    [spinnerActions]
  );

  const onSubmit = (data) => {
    forgotPassword(data, backToLogin);
  };

  const backToLogin = () => {
    changeFormType(formTypes.TYPE_LOGIN);
  };

  return (
    <div className="forgot-form">
      <div className="d-flex justify-content-center mb-5">
        <img src={LogoIcon} alt="Bayview Shores" height={49} />
        <p className="login-brand-logo">Bayview Shores</p>
      </div>
      <div className="form-heading">Forgot Password?</div>
      <div className="forgot-desc">
        Recover your password if you have forgotten it.
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <input
          className={`auth-form-input ${errors.email ? "is-invalid" : ""}`}
          placeholder="Enter your email"
          {...register("email")}
        />
        {errors.email && <div className="error">{errors.email.message}</div>}
        <RoundedButton
          cotainerClass="d-flex justify-content-center bottom-button "
          className="auth-button mx-auto bg-light border-light w-65 py-2"
          type="submit"
          disabled={spinner(authConstants.FORGOT) > -1}
        >
          {spinner(authConstants.FORGOT) > -1 ? "Submitting..." : "Submit"}
        </RoundedButton>
      </form>
    </div>
  );
};

const mapStateToProps = (state) => ({
  spinnerActions: state.systemReducer.spinnerActions,
});

const mapDispatchToProps = (dispatch) => ({
  forgotPassword: (data, onSuccess) =>
    dispatch(authActions.forgotPasswordSendEmail(data, onSuccess)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ForgotForm);
